import { render } from "./newsAndActivities.vue?vue&type=template&id=07f9ca64&scoped=true"
import script from "./newsAndActivities.vue?vue&type=script&lang=js"
export * from "./newsAndActivities.vue?vue&type=script&lang=js"

import "./newsAndActivities.vue?vue&type=style&index=0&id=07f9ca64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f9ca64"]])

export default __exports__